const formacao = [
  { label: "Analfabeto", id: "analfabeto" },
  { label: "Primeiro grau", id: "primeiro grau" },
  { label: "Segundo grau", id: "segundo grau" },
  { label: "Superior", id: "superior" },
  { label: "Pós-graduação", id: "pos graduacao" },
  {
    label: "Mestrado e/ou Doutorado",
    id: "mestrado ou doutorado",
  },
];

const sexo = [
  { label: "Masculino", id: "masculino" },
  { label: "Feminino", id: "feminino" },
];

const tipo = [
  { label: "Administrador", id: 1 },
  { label: "Consultor", id: 2 },
];

const status = [
  { label: "Ativo", id: "true" },
  { label: "Inativo", id: "false" },
];

export { formacao, sexo, tipo, status };
